import update from 'immutability-helper';
import {
    SET_ADMIN_MODE,
    UPDATE_USER_DATA,
    SET_API_KEY,
    TOGGLE_TRIAL_STATUS_PANEL,
    SET_IS_USER_SLACK_AUTH,
    SET_MFA_ACTIVATED,
} from '../actions/user';

const initialState = {
    adminMode: false,
    data: {},
    showTrialStatusPanel: false,
};

const user = (state = initialState, action) => {
    switch (action.type) {
        case SET_ADMIN_MODE: {
            return update(state, {
                adminMode: {
                    $set: action.enabled,
                },
            });
        }
        case UPDATE_USER_DATA: {
            return update(state, {
                data: {
                    $set: action.data,
                },
            });
        }
        case SET_API_KEY: {
            return update(state, {
                data: {
                    api_key: {
                        $set: action.api_key,
                    },
                },
            });
        }
        case TOGGLE_TRIAL_STATUS_PANEL: {
            const newState = update(state, {
                showTrialStatusPanel: {
                    $set: action.show,
                },
            });
            if (action.trialRealDaysLeft !== undefined) {
                newState.trialRealDaysLeft = action.trialRealDaysLeft;
            }

            if (action.trialDaysLeftToDisplay !== undefined) {
                newState.trialDaysLeftToDisplay = action.trialDaysLeftToDisplay;
            }

            return newState;
        }
        case SET_MFA_ACTIVATED: {
            return update(state, {
                data: {
                    mfa_activated: {
                        $set: action.mfaActivated,
                    },
                },
            });
        }
        case SET_IS_USER_SLACK_AUTH: {
            return update(state, {
                data: {
                    is_slack_auth: {
                        $set: action.isUserSlackAuth,
                    },
                },
            });
        }
        default:
            return state;
    }
};

export default user;
